// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"b1739ead","787":"464b25cf","850":"47c02120"}[chunkId] + ".chunk.js";
};